import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from 'seedling/constants';

/*
 * Tags are simple things that users can modify.
 */
const Tag = styled.span`
  font-size: ${props => props.fontSize};
  border-radius: 24px;
  padding: 3px 10px;
  display: inline-block;
  vertical-align: middle;
  text-align: left;

  color: ${props => props.color};
  background-color: ${props => props.backgroundColor};
  border: 1px solid ${props => props.borderColor};

  margin: 2px;
`;

Tag.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  fontSize: PropTypes.string,
};

Tag.defaultProps = {
  color: colors.darkestGrey,
  backgroundColor: colors.white,
  borderColor: colors.lightGrey,
  fontSize: '13px',
};

Tag.displayName = 'Tag';

export default Tag;
